var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0469 0.000976562C5.45578 0.000976562 0 5.36301 0 11.9541C0 18.5452 5.45578 24.001 12.0469 24.001C18.6379 24.001 24 18.5452 24 11.9541C24 5.36301 18.6379 0.000976562 12.0469 0.000976562ZM17.9635 15.8818C18.5119 16.4302 18.5119 17.3222 17.9635 17.8712C17.4192 18.4149 16.5272 18.4238 15.974 17.8712L12.0469 13.9425L8.02545 17.8716C7.47703 18.42 6.585 18.42 6.0361 17.8716C5.48766 17.3231 5.48766 16.4312 6.0361 15.8822L9.9642 11.9541L6.0361 8.02599C5.48766 7.47707 5.48766 6.58504 6.0361 6.0366C6.585 5.48817 7.47703 5.48817 8.02545 6.0366L12.0469 9.96564L15.974 6.0366C16.5215 5.4891 17.4136 5.48723 17.9635 6.0366C18.5119 6.58504 18.5119 7.47707 17.9635 8.02599L14.0354 11.9541L17.9635 15.8818Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelRounded);
export default __webpack_public_path__ + "static/media/cancel-rounded.4352c59f68ad8fe73de6c04d33a3c451.svg";
export { ForwardRef as ReactComponent };